import { render, staticRenderFns } from "./ChatXC.vue?vue&type=template&id=6ed4be01"
import script from "./ChatXC.vue?vue&type=script&lang=js"
export * from "./ChatXC.vue?vue&type=script&lang=js"
import style0 from "./ChatXC.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports